export default {
    RETRATO: 'portrait',
    PAISAGEM: 'landscape',
}
